







































import KaiCheckbox from '../common/KaiCheckbox.vue'
import { computed, defineComponent } from '@vue/composition-api'
import { Tag, UITag } from '../../types/tag'
import colorScheme from '../../colorScheme'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  name: 'SelectedTagCategory',
  components: {
    KaiCheckbox,
    FontAwesomeIcon
  },
  props: {
    title: {
      type: String,
      required: false
    },
    tags: {
      type: Array as () => UITag[],
      required: true
    },
    color: {
      type: String,
      default: 'blue'
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isCheckboxChecked = computed((): boolean => {
      if (props.tags) {
        return props.tags.every((currentValue: Tag) => currentValue.isVisible)
      }

      return false
    })

    return {
      isCheckboxChecked,
      colorScheme,
      iCaretUp: faCaretUp
    }
  }
})
